export default "__VITE_ASSET__BkC8LQZ___"